import React from 'react';

import { Box, Grid } from '@mui/material';
import { noop } from 'lodash';
import { useTranslation } from 'next-i18next';

import { AvailableButtonStyle } from '@components/molecules/enrollButton/availableButton/style';
import LikeAndShareCourse from '@components/share/custom/likeAndShareCourse';
import PurchaseRemark from '@components/share/custom/purchaseRemark';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type EnrollmentExpiredButtonProps = {
  isFooter?: boolean;
  isDisableActionIcon?: boolean;
  onClick: typeof noop;
  courseDetailSeo: CourseEntity;
};

const EnrollmentExpiredButton = ({
  isFooter = false,
  isDisableActionIcon = false,
  onClick,
  courseDetailSeo,
}: EnrollmentExpiredButtonProps) => {
  const { t } = useTranslation('store_course');

  return (
    <Grid container spacing={2} padding={0}>
      <Grid item md={12} xs={isFooter ? 6 : 12} padding={0}>
        <PurchaseRemark
          isFooter={isFooter}
          title={t('course_detail.header_banner.purchase.expired.remark')}
          icon="fa-light fa-circle-exclamation"
          style={{
            width: '100%',
            height: '40px',
          }}
        />
      </Grid>
      <Grid item md={12} xs={isFooter ? 6 : 12} padding={0}>
        <Box display="flex" height={isFooter ? '40px' : '60px'}>
          <AvailableButtonStyle
            onClick={onClick}
            isFooter={isFooter}
            variant="contained"
            color="inherit"
            style={{ width: '100%', height: '100%', padding: 0 }}
          >
            {t('course_detail.header_banner.purchase.expired.button.text')}
          </AvailableButtonStyle>
          {!isDisableActionIcon && <LikeAndShareCourse courseDetailSeo={courseDetailSeo} />}
        </Box>
      </Grid>
    </Grid>
  );
};

export default EnrollmentExpiredButton;
